import * as React from 'react';
import { cn } from '@/lib/utils';

export function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      className={cn(
        'flex min-h-20 w-full resize-y border border-input bg-secondary px-3 py-2 text-sm text-foreground',
        'placeholder:text-muted-foreground/70',
        'focus-visible:border-primary focus-visible:outline-1 focus-visible:outline-primary',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'aria-invalid:border-destructive',
        className,
      )}
      {...props}
    />
  );
}
